import { Theme, useMediaQuery, useTheme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import CloseIcon from "@material-ui/icons/Close"
import { get } from "browser-cookies"
import React, { useContext } from "react"
import { AppContext } from "Views/Home/context"
import cal from "clsx"
import { CalendarContext } from "../context"
import { Board, BoardAction, BoardModifyDialog } from "Types/board"
import { useMouseGesture } from "Hooks/basic"
import { InitialModal } from "Methods/modal"

const useStyles = makeStyles((theme: Theme) => ({
    draftItem: {
        position: "relative",
        borderRadius: 6,
        padding: "0 20px 0 10px",
        cursor: "pointer",
        transition: "all .3s ease",
        wordBreak: "break-word",
        userSelect: "none",
        width: "80%",
        height: 40,
        color: "white",
        marginTop: 10,
        textAlign: "left",
        overflowY: "scroll",
        //
        // "&:hover": {
        //     width: "90%",
        //     height: 40,
        //     transition: "all .3s ease",
        //     overflowY: "scroll",
        // },
    },
    move: {
        width: "90%",
        height: 40,
        transition: "all .3s ease",
        cursor: "move",
        border: "2px dashed #ddd",
        opacity: 0.6,
    },
    icon: {
        fontWeight: "bold",
        position: "absolute",
        right: 1,
        top: 0,
        opacity: 0,
    },
    iconShow: {
        opacity: 1,
    },
    redDot: {
        position: "absolute",
        width: 10,
        height: 10,
        left: 0,
        borderRadius: "100%",
        backgroundColor: "red",
    },
}))
interface ComponentProps {
    board: Board,
    onDelete: (boardId: number) => void,
}
let pressTimer: number
const pressTimeout = 200
const CandidateItem = (props: ComponentProps) => {
    const classes = useStyles()
    const { board, onDelete } = props
    const { article_type, species_article_type, health_article_type, creator_id: creatorId, material, eat_article_type } = board
    const { color_code = "" } = article_type || species_article_type || eat_article_type || health_article_type || {}
    const { show, handleMouseEnter, handleMouseLeave } = useMouseGesture()
    const {
        handleChangeBoardModifyDialog, boardModifyDialog, channelName,
        privilegeMap, isWeChat, handleSetMovableBoard, movableBoard, isWeibo, isSpecies, isHealth
    } = useContext(CalendarContext)
    const privilege = privilegeMap.draft
    const userUid: string = get("uid") || ""
    const { user, handleChangeModal } = useContext(AppContext)

    const isAuthor = userUid === creatorId
    const { role, department } = user
    const { role_name } = role || {}
    const isTrueEditor = role_name === "true_editor"
    const isOpEditor = role_name === "op_editor"
    const isSideEditor  = role_name === "side_editor"
    const isNewMedia = department ? department.type_name === 'newmedia' : false
    const isEat = channelName === '吃货'
    const handleEditDraft = (event: React.MouseEvent) => {
        event.stopPropagation()
        if (
            (!isSpecies && !isEat && !isHealth && (privilege.update || isAuthor))
            || (isSpecies && (isTrueEditor || isOpEditor || (isSideEditor && isAuthor)))
            || (isEat && ((isSideEditor && isNewMedia) || isAuthor))
            || (isHealth && (isTrueEditor || isOpEditor || isSideEditor))
        ) {
            let type: BoardAction
            switch (channelName) {
                case '微信':
                    type = 'draft_update';
                    break;
                case '微博':
                    type = 'weibo_draft_update';
                    break;
                case '吃货':
                    type = 'eat_draft_update'
                    break
                case '果壳自然':
                    type = 'species_draft_update';
                    break
                default:
                    type = 'health_draft_update';
                    break
            }

            handleChangeBoardModifyDialog({
                ...(boardModifyDialog as BoardModifyDialog),
                show: true,
                board,
                type,
            })
        }
    }
    const handleStartMove = (event: React.MouseEvent) => {
        event.stopPropagation()
        if (
            (privilege.update && (isWeChat || isWeibo)) ||
            (isSpecies && isTrueEditor) ||
            (channelName === '吃货' && isSideEditor) ||
            (isHealth && (isTrueEditor || isOpEditor || isSideEditor))
        ) {
            pressTimer = window.setTimeout(() => {
                handleSetMovableBoard(board)
            }, pressTimeout)
        }
    }
    const isMove = board.id === (movableBoard && movableBoard.id)
    const handleEndMove = () => {
        window.clearTimeout(pressTimer)
        handleSetMovableBoard(null)
    }
    const handleDeleteDraft = (event: React.MouseEvent) => {
        event.stopPropagation()
        handleChangeModal({
            show: true,
            type: "warning",
            title: `确定删除备选 ${board.name || board.description}？`,
            showCancel: true,
            onConfirm: async () => {
                try {
                    if (board.id) {
                        await onDelete(board.id)
                        handleChangeModal({
                            show: true,
                            type: "success",
                            title: "已删除！",
                            timeout: 800,
                            customButtons: [],
                            onConfirm: () => {
                                handleChangeModal(InitialModal)
                            },
                        })
                    }
                } catch (e) {
                    if (!navigator.onLine) {
                        handleChangeModal({
                            show: true,
                            type: "warning",
                            customButtons: [],
                            title: "oops! 断网啦！",
                            timeout: 3000,
                            onConfirm: () => {
                                handleChangeModal(InitialModal)
                            },
                        })
                        return
                    }
                }
            },
            onCancel: () => {
                handleChangeModal(InitialModal)
            },
        })
    }
    let showText = board.name
    if (isWeChat) {
        showText = `${board.author ? `【${board.author.name}】` : ""}${board.description}`
    }

    const showRedDot = material ? material !== null && (material.status === "unfilled" || material.status === "unfinished") : false

    const theme = useTheme()
    const wideScreen = useMediaQuery(theme.breakpoints.up('md'))

    return (
        <div
            className={cal(
                classes.draftItem,
                isMove && classes.move,
            )}
            style={{ backgroundColor: color_code || "#8ED1FC" }}
            // onMouseEnter={handleMouseEnter}
            // onMouseLeave={handleMouseLeave}
            onClick={handleEditDraft}
            // onMouseDown={handleStartMove}
            // onMouseUp={handleEndMove}
            onPointerEnter={handleMouseEnter}
            onPointerLeave={handleMouseLeave}
            onPointerDown={handleStartMove}
            onPointerUp={handleEndMove}
        >
            <div className={cal(
                classes.redDot,
            )} style={{ opacity: showRedDot ? 1 : 0 }} />
            {showText}
            {(
                (!isSpecies && !isEat && !isHealth && (isAuthor || isTrueEditor || isOpEditor) && (show || !wideScreen))
                || (isSpecies && (isTrueEditor || (isSideEditor && isAuthor)))
                || (isEat && ((isSideEditor && isNewMedia) || isAuthor) && (show || !wideScreen))
                || (isHealth && (isTrueEditor || isSideEditor))
            ) && (
                <CloseIcon
                    fontSize="small"
                    className={cal(
                        classes.icon,
                        (show || !wideScreen) && classes.iconShow,
                    )}
                    onClick={handleDeleteDraft}
                />
            )}
        </div>
    )
}

export default CandidateItem
